import React, { useState, useEffect ,useRef} from 'react';
import { Row, Col, Card, Button, Input, Label, CardSubtitle } from 'reactstrap';
import UpdateAccountDetailsService from '../../../../../../../Service/OPSServices/AccountDetailsService/UpdateAccountDetailsService';
import { connect } from "react-redux";
import ReactTable from 'react-table';
import CustomModal from '../../../../../../Components/Modals/CustomModal';
import AddUserFormPopup from '../../../../UserProfileData/Components/AddUserFormPopup';
import AddUserService from '../../../../../../../Service/DashboardServices/UserProfileServices/ProfileDataServices/AddUserService';
import FetchStoreAndUserDataService from '../../../../../../../Service/OPSServices/AccountDetailsService/FetchStoreAndUserDataService';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave,faEdit } from '@fortawesome/free-solid-svg-icons';

import { EditAccountDetailsCard, EditAccountDetailsCard1 } from './EditAccountDetailsCard';
import LoadingOverlay from 'react-loading-overlay';
import Loader from 'react-loaders';
import ProductsPagination from '../../../../../../Components/Pagination/ProductsPagination';
import AccountUpdateProfileService from '../../../../../../../Service/OPSServices/AccountDetailsService/AccountUpdateProfileService';
import UpdateAgenciesUserActivityeService from '../../../../../../../Service/OPSServices/AccountDetailsService/UpdateAgenciesUserActivityeService';
import MapAccountStoreUserService from '../../../../../../../Service/OPSServices/AccountDetailsService/MapAccountStoreUserService';
import AssociateStoresToAccountDetails from './AssociateStoresToAccountDetails';
import { previousFriday } from 'date-fns';
import UpdateAccountUserRolesService from '../../../../../../../Service/OPSServices/AccountDetailsService/UpdateAccountUserRolesService';
import FetchStoreUserRoleMappingDataService from '../../../../../../../Service/OPSServices/AccountDetailsService/FetchStoreUserRoleMappingDataService';
import UpdateStoreUserRoleMappingService from '../../../../../../../Service/OPSServices/AccountDetailsService/UpdateStoreUserRoleMappingService';
function UpdateExistingAccountDetails(props) {

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [addUserPopUp, setAddUserPopUP] = useState(false)
  const [teamMembers, setTeamMembers] = useState()
  const [memberRoles, setMemberRoles] = useState()
  const [storeList, setStoreList] = useState('')
  const [accountDetails, setAccountDetails] = useState()
  const [userSerachTeaxt, setUserSerachTeaxt] = useState('')
  const [storeSerachText, setStoreSerachText] = useState('')
  const [storeUserSerachTeaxt, setStoreUserSerachTeaxt] = useState('')

  const [updateAccountDetails, setUpdateAccountDetails] = useState(false)
  const [expandedRow, setExpandedRow] = useState(null);
  const [userListCurrentPage, setUserListCurrentPage] = useState(0);
  const [storeListCurrentPage, setStoreListCurrentPage] = useState(0);
  const [storeUserListCurrentPage, setStoreUserListCurrentPage] = useState(0);
  const [refreshDataFlag, setRefreshDataFlag] = useState(false);
  const [updateProfilespopup, setUpdateProfilespopup] = useState(false)
  const [associateStoresPopup, setAssociateStoresPopup] = useState(false)
  const [userListConfirmationPopup, setUserListConfirmationPopup] = useState(false);
  const [selectedUserList, setSelectedUserList] = useState(null);
  const [storeListPermissionPopup, setStoreListPermissionPopup] = useState(false);
  const [selectedStoreList, setSelectedStoreList] = useState();
  const [storeUserListData, setStoreUserListData] = useState('');
  const [selectedStoreBg, setSelectedStoreBg] = useState('');
  const [changeRole,setChangeRole]=useState(false)
  const [newRoleForUser,setNewRoleForUser]=useState()
  const [simpliUserId,setSimpliUserId]=useState()
  const [selectedUser, setSelectedUser]=useState()
  const [inactiveSaveButton,setInactiveSaveButton]=useState(false)
  const [mappingTable, setMappingTable] = useState([]);
  const [memberDropdown, setMemberDropdown] = useState([]);
  const [mappingSearchText, setMappingSearchText] = useState('');
  const [mappingCurrentPage, setMappingCurrentPage] = useState(0);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  useEffect(() => {
    let data = { id: props.accountDetails }
    FetchStoreUserRoleMappingDataService(props.token,data).then((res) => {
      if (res) {
        console.log(res)
        setMappingTable(res.tableData);
        setMemberDropdown(res.memberDropdown);
      }
    });
  }, []);

  const ViewStoreUsers = (data) => {
    // setExpandedRow(prev => (prev === integerID ? null : integerID));
    setStoreUserListData(data.userList)
    setSelectedStoreBg(data.integerID)
  };

  useEffect(() => {
    let data = { id: props.accountDetails }
    setLoading(true);
    FetchStoreAndUserDataService(props.token, data).then((res) => {
      if (res) {
        console.log(res)
        setFormData(res.agenciesData[0])
        setTeamMembers(res.simpliusers)
        const role = res.role_List.filter((role) => role.Account_Types_id == res.agenciesData[0].Account_Types_id)
        setMemberRoles(role)
        setStoreList(res.store_List)
        setAccountDetails(res.accountTyps)
        if (res.store_List && Array.isArray(res.store_List) && res.store_List.length > 0) {
          setStoreUserListData(res.store_List[0].userList || '');
          setSelectedStoreBg(res.store_List[0].integerID || '');
      } else {
          setStoreUserListData('');
          setSelectedStoreBg('');
      }
        setLoading(false);


      }


    })

  }, [refreshDataFlag]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".dropdown-wrapper")) {
        setOpenDropdownId(null);
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
  
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleAddUser = (newUser) => {
    AddUserService(props.token, newUser).then((res) => {
      if (res) {
        console.log(res)
        setTeamMembers(res.simpliusers)
        setStoreList(res.store_List)
        const firstStore = Array.isArray(res.store_List) && res.store_List.length > 0 ? res.store_List[0] : null;
        setStoreUserListData(firstStore?firstStore.userList:'' || '');
        setSelectedStoreBg(firstStore?firstStore.integerID:'' || '');
        
        // props.setUserData(res.userData);
        // setFilteredUsers(res.userData);
        setAddUserPopUP(false);
      }
    });
  };
  const handelAddUser = () => {
    setAddUserPopUP(true)
  }
  const filterUsers = teamMembers && teamMembers.filter((row) => {
    const name = (row.fullName || '').toLowerCase();
    const role = (row.roleNames || '').toLowerCase();
    const email = (row.email || '').toLowerCase()
    const phoneNumber = (row.phoneNumber || '').toLowerCase()

    return name.includes(userSerachTeaxt.toLowerCase()) || role.includes(userSerachTeaxt.toLowerCase())|| phoneNumber.includes(userSerachTeaxt.toLowerCase()) || email.includes(userSerachTeaxt.toLowerCase())
  })
  const filterStores = storeList && storeList.filter((row) => {
    const storeName = (row.name || '').toLowerCase()
    const location = (row.location || '').toLowerCase()
    const stringID = (row.stringID || '').toLowerCase()
    return stringID.includes(storeSerachText.toLowerCase()) || storeName.includes(storeSerachText.toLowerCase()) || location.includes(storeSerachText.toString().toLowerCase())
  })
  const filterStoreUsers = storeUserListData && storeUserListData.filter((row) => {
    const Name = (row.fullName || '').toLowerCase()
    const role = (row.role || '').toString().toLowerCase()
    return Name.includes(storeUserSerachTeaxt.toLowerCase())
      || role.includes(storeUserSerachTeaxt.toString().toLowerCase())
  })
  // For UserList Pagination
  const userListPageSize = 5;
  const userListStartIndex = userListCurrentPage * userListPageSize;
  const userListEndIndex = userListStartIndex + userListPageSize;

  const totalFilteredUsers = filterUsers && filterUsers.length;
  const userListTotalPages = Math.ceil(totalFilteredUsers / userListPageSize);

  const handleUserListPageChange = (page) => {
    if (page >= 0 && page < userListTotalPages) {
      setUserListCurrentPage(page);
    }
  };

  const paginatedCombinedUsers = filterUsers && filterUsers.slice(userListStartIndex, userListEndIndex);
  const handleListSearchChange = (e) => {
    setUserSerachTeaxt(e);
    setUserListCurrentPage(0);  // Reset to the first page when searching
  };

  // For StoreList Paggination 
  const storeListPageSize = 5;
  const storeListStartIndex = storeListCurrentPage * storeListPageSize;
  const storeListEndIndex = storeListStartIndex + storeListPageSize;

  const totalFilteredStores = filterStores && filterStores.length;
  const storeListTotalPages = Math.ceil(totalFilteredStores / storeListPageSize);

  const handleStoreListPageChange = (page) => {
    if (page >= 0 && page < storeListTotalPages) {
      setStoreListCurrentPage(page);
    }
  };

  const paginatedCombinedStores = filterStores && filterStores.slice(storeListStartIndex, storeListEndIndex);


  const handleStoreListSearchChange = (e) => {
    setStoreSerachText(e);
    setStoreListCurrentPage(0);  // Reset to the first page when searching
  };

  // StoreUserList Pagination
  const storeUserListPageSize = 4;
  const storeUserListStartIndex = storeUserListCurrentPage * storeUserListPageSize;
  const storeUserListEndIndex = storeUserListStartIndex + storeUserListPageSize;
  const totalFilteredStoreUsers = filterStoreUsers && filterStoreUsers.length;
  const storeUserListTotalPages = Math.ceil(totalFilteredStoreUsers / storeUserListPageSize);

  const handleStoreUserListPageChange = (page) => {
    if (page >= 0 && page < storeUserListTotalPages) {
      setStoreUserListCurrentPage(page);
    }
  };
  const paginatedCombinedStoreUsers = filterStoreUsers && filterStoreUsers.slice(storeUserListStartIndex, storeUserListEndIndex);
  const handleStoreUserListSearchChange = (e) => {
    setStoreUserSerachTeaxt(e);
    setStoreUserListCurrentPage(0);  // Reset to the first page when searching
  };
  const handleUpdateAgenciesUserActivitye = (userData) => {
    console.log(userData)
    let data = {
      id: userData.id,
      accountId: formData.id
    }
    UpdateAgenciesUserActivityeService(props.token, data).then((res) => {
      if (res) {
        console.log(res)
        setFormData(res.agenciesData[0])
        setTeamMembers(res.simpliusers)

      }
    })

  }
  const handleUpdateProfiles = () => {
    setUpdateProfilespopup(true)
    let data = {
      AccountId: formData.id
    }
    AccountUpdateProfileService(props.token, data).then((res) => {
      if (res) {
        console.log(res)
      }
    })

  }
  const handleAssociateStores = () => {
    setAssociateStoresPopup(true)
  }

  const mapAccountStoreUser = (user, store) => {
    let data = {
      integerID: selectedStoreBg,
      userId: user.id,
      flag: user.mappingActive,
      accountId: formData.id
    }
    MapAccountStoreUserService(props.token, data).then((res) => {
      if (res) {
        console.log(res);
        setStoreList(res.store_List)
        const selectedUserBuIntId = res.store_List && res.store_List.find((store) => store.integerID == selectedStoreBg)
        console.log(selectedUserBuIntId)
        setStoreUserListData(selectedUserBuIntId.userList)
      }
    })
  }
  const handleUserListActiveToggle = (user) => {
    setSelectedUserList(user);
    setUserListConfirmationPopup(true);
  };
  const confirmUserListActiveStatus = () => {
    if (selectedUserList) {
      handleUpdateAgenciesUserActivitye(selectedUserList);
      setUserListConfirmationPopup(false);
      setSelectedUserList(null);
    }
  };
  const cancelUserListActiveStatus = () => {
    setUserListConfirmationPopup(false);
    setSelectedUserList(null);
  };
  const handleGrantPermission = (store, user) => {
    setSelectedStoreList(store);
    setSelectedUserList(user);
    setStoreListPermissionPopup(true);
  };
  const confirmGrantPermission = () => {
    if (selectedUserList && selectedStoreList) {
      mapAccountStoreUser(selectedUserList, selectedStoreList);
    }
    setStoreListPermissionPopup(false);
    setSelectedStoreList(null);
    setSelectedUserList(null);
  };

  const cancelGrantPermission = () => {
    setStoreListPermissionPopup(false);
    setSelectedStoreList(null);
    setSelectedUserList(null);
  };
  const handleChangeRole=(role)=>{
    console.log(role);
    setSelectedUser(role.id) 
    setSimpliUserId(role.roles)
    setChangeRole(true)
  }
  const handleMemberRoleChange=(e)=>{
   let roleId=e.target.value
    setNewRoleForUser(roleId)
  }
  
  const handleChangeUSerRole=()=>{
    let data={
      roleId:newRoleForUser,
      accountId:formData.id,
      simpliuser:selectedUser,
      // newRoleForUser:newRoleForUser,
      
    }
    setInactiveSaveButton(true)
    UpdateAccountUserRolesService(props.token,data).then((res)=>{
      if(res){
        console.log(res);
        setTeamMembers(res.simpliusers)
        setTeamMembers(res.simpliusers)
        setStoreList(res.store_List)
        setChangeRole(false)
        const firstStore = Array.isArray(res.store_List) && res.store_List.length > 0 ? res.store_List[0] : null;
        setStoreUserListData(firstStore?firstStore.userList:'' || '');
        setSelectedStoreBg(firstStore?firstStore.integerID:'' || '');
        setInactiveSaveButton(false)

      }
    })
  
  }

   // ---------------Search and Pagination Functionality for Store User Role Mapping--------------
   const filteredMapping = mappingTable && mappingTable.filter((row) => {
    const store = (row.store || '').toLowerCase();
    const role = (row.role || '').toLowerCase();
    const user = (row.user || '').toLowerCase();
  
    return (
      store.includes(mappingSearchText.toLowerCase()) ||
      role.includes(mappingSearchText.toLowerCase()) ||
      user.includes(mappingSearchText.toLowerCase())
    );
  });

  const mappingPageSize = 5;

const mappingStartIndex = mappingCurrentPage * mappingPageSize;
const mappingEndIndex = mappingStartIndex + mappingPageSize;

const totalFilteredMapping = filteredMapping ? filteredMapping.length : 0;

const mappingTotalPages = Math.ceil(totalFilteredMapping / mappingPageSize);

const handleMappingPageChange = (page) => {
  if (page >= 0 && page < mappingTotalPages) {
    setMappingCurrentPage(page);
  }
};

const paginatedMapping = filteredMapping
  ? filteredMapping.slice(mappingStartIndex, mappingEndIndex)
  : [];


  const handleMappingChange = (e, row) => {
    const selectedUserId = e.target.value;
  
    const selectedUser = memberDropdown.find(
      (m) => m.id == selectedUserId
    );
  
    const updatedTable = mappingTable.map((item) => {
      if (item.id === row.id) {
        return {
          ...item,
          userId: selectedUserId,
          user: selectedUser ? selectedUser.name : ""
        };
      }
      return item;
    });
  
    setMappingTable(updatedTable);
  };

  
  // ----------------------------------------------------------------------------------------------
  const handleCheckboxChange = (e, userId, row) => {
    console.log("row data:", row);
    let updatedUserIds = row.userIds ? [...row.userIds] : [];
  
    if (e.target.checked) {
      updatedUserIds.push(userId);
    } else {
      updatedUserIds = updatedUserIds.filter((id) => id !== userId);
    }
  
    // UI update first
    const updatedTable = mappingTable.map((item) => {
      if (item.id === row.id) {
        return {
          ...item,
          userIds: updatedUserIds,
          user: memberDropdown
            .filter((m) => updatedUserIds.includes(m.id))
            .map((m) => m.name)
            .join(", ")
        };
      }
      return item;
    });
  
    setMappingTable(updatedTable);
  
   
    let data = {
      storeId: row.storeId,
      roleId: row.roleId,
      userIds: updatedUserIds
    }
    console.log("API data:", data); 
    UpdateStoreUserRoleMappingService(props.token, data).then((res) => {
      if (res) {
        console.log(res);
      }
    });
  };
  return (
    <>
      <LoadingOverlay
        active={loading}
        styles={{
          overlay: (base) => ({
            ...base,
            background: "#f1f4f6",
            opacity: 1,
          }),
          content: (base) => ({
            ...base,
            color: "#000",
          }),
        }}
        spinner={<Loader active type="ball-pulse" />}
        text="Loading Account details..."
      >
       <Card
        className={`p-3 ${props.action ? '' : 'hide-card-style'}`}
        style={{ background: '#d2f1b1' }}
      >
          {/* {props.action == true ? <h4 className='mt-2 mb-4 border p-2 text-center' style={{ fontSize: '20px', color: '#243837', backgroundColor: '#B1FA63' }}>Account Details</h4> : ""} */}
          {/* <h4 className='ml-1'><b>Account Details</b></h4> */}
          <Row className='mt-1'>
            <Col md={6}>
              <Card className="p-4 accountdetails-card" style={{ height: '429px' }}>
              <Row>
                <Col md={4}>
              <h5 className="mb-3"><b>Store User Role Mapping</b></h5>
              </Col>
              <Col md={8}>
                <div className="d-flex justify-content-end mb-2">
                  <Input
                    type="text"
                    className="w-50"
                    placeholder="Search..."
                    value={mappingSearchText}
                    onChange={(e) => {
                      setMappingSearchText(e.target.value);
                      setMappingCurrentPage(0); 
                    }}
                  />

                  <div className="ml-3 mt-2">
                    <ProductsPagination
                      currentPage={mappingCurrentPage}
                      totalRecords={totalFilteredMapping}
                      pageSize={mappingPageSize}
                      onPageChange={handleMappingPageChange}
                    />
                  </div>
                </div>
                </Col>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Store</th>
                      <th>Role</th>
                      <th>Member Dropdown</th>
                      <th>Member List</th>
                    </tr>
                  </thead>

                  <tbody>
                    {paginatedMapping && paginatedMapping.length > 0 ? (
                      paginatedMapping.map((row, index) => (
                        <tr key={index}>

                          {/* Store */}
                          <td>{row.store}</td>

                          {/* Role */}
                          <td>{row.role}</td>

                          <td style={{ position: "relative" }}>
                          <div 
                            className="dropdown-wrapper"
                            onMouseDown={(e) => e.stopPropagation()}
                          >
                            <div className="custom-select-box" 
                             style={{ color: '#767373' }} 
                           onClick={(e) => {
                            e.stopPropagation();   
                            setOpenDropdownId(openDropdownId === row.id ? null : row.id);
                          }}>
                              --Select Members--
                            </div>

                            {openDropdownId === row.id && (
                              <div className="custom-dropdown">
                                {memberDropdown.map((m) => (
                                  <label key={m.id} className="dropdown-item">
                                    <input
                                      type="checkbox"
                                      checked={row.userIds && row.userIds.includes(m.id)}
                                      onChange={(e) => handleCheckboxChange(e, m.id, row)}
                                    />
                                    <span className="ml-2">{m.name}</span>
                                  </label>
                                ))}
                              </div>
                            )}
                            </div>
                          </td>

                          {/* Selected Member */}
                          <td>{row.user}</td>

                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Row>
              </Card>
            </Col>
           
            <Col md={6}>

              <Card className="accountdetails-rounded-card p-3 " style={{ height: '429px' }}>

                <Row>
                  <Col md={4}> <h5 className='ml-2 mt-1'><b>Account Users </b></h5></Col>
                  <Col md={8}>
                    <div className='d-flex justify-content-end'>

                      <Input type='text'
                        className='w-25 mb-2 h-75'
                        placeholder='Search...'
                        value={userSerachTeaxt}
                        onChange={(e) => handleListSearchChange(e.target.value)}
                      />

                      <div className="d-flex justify-content-end  text-md-right  mb-2 ml-3 mr-3">
                        <ProductsPagination
                          currentPage={loading ? 0 : userListCurrentPage}
                          totalRecords={loading ? 0 : totalFilteredUsers}
                          pageSize={userListPageSize}
                          onPageChange={handleUserListPageChange}
                        />
                      </div>
                      <div md={3} className='mb-1  text-md-right'>
                        <Button
                          onClick={() => handelAddUser()} className='btn-background-color'
                        >Add User
                        </Button>
                      </div>
                    </div>
                  </Col>

                </Row>
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col" className="text-center">Active</th>
                      <th scope="col">Name</th>
                      <th scope="col">Role</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedCombinedUsers && paginatedCombinedUsers && paginatedCombinedUsers.length>0 ? (
                      paginatedCombinedUsers.map((user, index) => (
                        <tr key={index}>
                          <td className="text-center">
                            <input
                              type="checkbox"
                              checked={user.isActive} // or use a boolean field if available
                              style={{ cursor: 'pointer' }}
                              // onClick={() => handleUpdateAgenciesUserActivitye(user)}
                              onChange={() => handleUserListActiveToggle(user)}
                              readOnly
                            />
                          </td>
                          <td><p title={user.fullName} className='mb-0 comment-paragraph-account-username'>{user.fullName}</p></td>
                          <td>
                            <div>
                            <span className='cursor-pointer' onClick={()=>handleChangeRole(user)}> {user.roleNames}</span>
                            </div>
                           </td>
                          <td>{user.phoneNumber}</td>
                          <td ><p title={user.email} className="mb-0 ">{user.email}</p></td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">No data found...</td>
                      </tr>
                    )}
                  </tbody>
                </table>

              </Card>
            </Col>
          </Row>


          <Row className='mb-2 mt-4'>
            <Col className='d-flex'>
            <div>
            <Card className="p-2 storelist-rounded-card no-card-shadow" style={{ height: '344px', boxShadow: 'none' }}>
                <Row className='mt-3'>
                  
                  <Col md={12} className='d-flex'>
                  {props.action== false &&
                  <div className='d-flex justify-content-start ml-2'>
                    <h5 className='mt-1'><b>Store List</b></h5></div>
                  }

  
                {/* <div className='d-flex justify-content-start ml-2'> */}
                    <div className={(formData.Account_Types ==='Agency' ||formData.Account_Types === 'SW Team')?'d-flex justify-content-start ml-2':'d-flex justify-content-end ml-2'}>

                      {props.action== true &&
                      <h5 className='ml-1 mt-1'><b>Store List</b></h5>}
                    
                      <Input type='text'
                        className='w-25 ml-2 mb-2 h-75'
                        placeholder='Search...'
                        value={storeSerachText}
                        onChange={(e) => handleStoreListSearchChange(e.target.value)} />

                      <div className="d-flex justify-content-end  mb-2 ml-3">
                        <ProductsPagination
                          currentPage={loading ? 0 : storeListCurrentPage}
                          totalRecords={loading ? 0 : totalFilteredStores}
                          pageSize={storeListPageSize}
                          onPageChange={handleStoreListPageChange}
                        />
                      </div>
                      <div className='mb-1 ml-3 text-md-right justify-content-end'>
                        <Button
                          onClick={() => handleUpdateProfiles(true)}
                          className='btn-background-color'
                        >Update Profiles
                        </Button>
                      </div>

                    {(formData.Account_Types ==='Agency' ||formData.Account_Types === 'SW Team')? <div className='mb-1 ml-3 text-md-right justify-content-end'>

                        <Button
                          onClick={() => handleAssociateStores(true)}
                          className='btn-background-color'
                        >Associate Stores
                        </Button>

                      </div>:''}

                    </div>


                  </Col>
                </Row>

                <table className="table ml-2">
                  <thead>
                    <tr>
                      {/* <th>Store ID</th> */}
                      <th>Name</th>
                      <th>Location</th>
                      <th>Seller Partner ID</th>
                      {/* <th>Timezone</th> */}
                      {/* <th>User List</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedCombinedStores && paginatedCombinedStores.length > 0 ? (
                      paginatedCombinedStores.map((store, index) => (

                        <React.Fragment key={index}>
                          <tr onClick={() => ViewStoreUsers(store)} style={selectedStoreBg == store.integerID ? { cursor: 'pointer', background: '#fedecb' } : { cursor: 'pointer' }}>
                            {/* <td>{store.integerID}</td> */}
                            <td><p title={store.name} className="mb-0 comment-paragraph-account-email"> {store.name}</p></td>
                            <td>{store.location}</td>
                            <td>{store.stringID}</td>

                          </tr>


                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No Data Found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Card>
            {/* </Col> */}
            </div>
            <div>
            {/* <Col md={5}> */}
            <Card className="p-3 accountDetails-card-style no-card-shadow" style={{ boxShadow: 'none' }}>

                <div className='d-flex'>

                  <h5 className='ml-1 mt-1 mr-5'><b>Assigned Users </b></h5>
                  <Input type='text'
                    className='w-25  ml-3 mb-2 h-75'
                    placeholder='Search...'
                    value={storeUserSerachTeaxt}
                    onChange={(e) => handleStoreUserListSearchChange(e.target.value)}
                  />
                  <div className="d-flex justify-content-end  text-md-right  mb-2 ml-3">
                    <ProductsPagination
                      currentPage={loading ? 0 : storeUserListCurrentPage}
                      totalRecords={loading ? 0 : totalFilteredStoreUsers}
                      pageSize={storeUserListPageSize}
                      onPageChange={handleStoreUserListPageChange}
                    />
                  </div>
                </div>
                <table className="table mb-0">
                  <thead>
                    <tr>

                      <th>Name</th>
                      <th>Role</th>
                      <th>Grant Permission</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedCombinedStoreUsers && paginatedCombinedStoreUsers.length > 0 ? (
                      paginatedCombinedStoreUsers.map((user, idx) => (
                        <tr key={idx}>

                          <td><p className='mb-0 comment-paragraph-account-storeuser'>{user.fullName}</p></td>
                          <td>{user.role}</td>
                          <td className="mr-2 text-center">
                            <div style={{ marginRight: '3.5rem' }}>
                              <input
                                type="checkbox"
                                checked={user.mappingActive}
                                style={{ cursor: 'pointer' }}
                                onChange={() => handleGrantPermission(paginatedCombinedStoreUsers, user)}
                                readOnly
                              />
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" >
                          <p className="mb-0 d-flex justify-content-center">No users found.</p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Card>
              </div>
            </Col>
          </Row>

        </Card>
      </LoadingOverlay>
      <CustomModal
        header={'Add User'}
        isOpen={addUserPopUp}
        toggle={() => { setAddUserPopUP(!addUserPopUp); }}
        size={"lg"}
        className='curve-popup'
      >
        <AddUserFormPopup
          onSubmit={handleAddUser}
          memberRoles={memberRoles}
          AccountDetailsId={formData.id}
          accountDetails={formData}
          AccountName={formData.name}
          closeModal={function () { setAddUserPopUP(false) }} />
      </CustomModal>
      <CustomModal
        header={'Confirm User Activation'}
        isOpen={userListConfirmationPopup}
        toggle={() => cancelUserListActiveStatus()}
        size="md"
        className='curve-popup'
      >
        <Label className="p-3">
          <p style={{ fontSize: '15px' }}><b>Are you sure you want to update this user's active status ? </b></p>
          <div className="text-right mt-4">
            <Button style={{ width: 55 }} onClick={(confirm) => confirmUserListActiveStatus(confirm)}
              className="btn-background-color">Yes</Button>
            <Button onClick={() => cancelUserListActiveStatus()} className="ml-3">No</Button>
          </div>
        </Label>
      </CustomModal>
      <CustomModal
        header={'Update Store Permission'}
        isOpen={storeListPermissionPopup}
        toggle={() => cancelGrantPermission()}
        size="md"
        className='curve-popup'
      >
        <div className="p-3">
          <p style={{ fontSize: '15px' }}><b>Are you sure you want to grant this user permission to access this store?</b></p>
          <div className="text-right mt-4">
            <Button style={{ width: 55 }} onClick={confirmGrantPermission}
              className="btn-background-color">Yes</Button>
            <Button onClick={() => cancelGrantPermission()} className="ml-3">No</Button>
          </div>
  </div>
      </CustomModal>
      <CustomModal
        header={'Associate Stores'}
        isOpen={associateStoresPopup}
        toggle={() => { setAssociateStoresPopup(!associateStoresPopup); }}
        size={"lg"}
        className='curve-popup'
      >
        <AssociateStoresToAccountDetails
          setStoreList={setStoreList}
          setTeamMembers={setTeamMembers}
          setStoreUserListData={setStoreUserListData}
          setSelectedStoreBg={setSelectedStoreBg}
          AccountDetailsId={formData.id}
          AccountDetailsName={formData.name}
          setAssociateStoresPopup={setAssociateStoresPopup}
           />
      </CustomModal>
      <CustomModal
        header={'Change Role'}
        isOpen={changeRole}
        toggle={() => { setChangeRole(!changeRole); }}
        size={"sm"}
        className='curve-popup'
      >
       <Card className='curve-popup p-3'>
       <select
          onClick={(e)=>handleMemberRoleChange(e)}
          className='form-control'>
            <option value="" disabled>--Select Role--</option>
            {memberRoles && memberRoles.map((role)=>(
                  <option key={role.id} value={role.id} selected={role.id==simpliUserId} >
                  {role.role}
              </option>
            ))}
          </select>  
          <div className='d-flex justify-content-center'>
          <Button
          disabled={inactiveSaveButton}
          className='btn-background-color w-25 text-center mt-2'
            onClick={()=>handleChangeUSerRole()}
        >  
        save
        </Button> 
          </div>
          

       </Card>
      </CustomModal>

    </>

  );

}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
    adProfiles: state.accountOverview.landing.adProfiles,
  };
};

export default connect(mapStateToProps)(UpdateExistingAccountDetails);

